import { Paper, Stack, Typography } from "@mui/material";

export const SafetyBox = () => (
  <Stack
    component={Paper}
    direction="row"
    variant="outlined"
    sx={{
      borderRadius: "4px",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      py: "10px",
      px: 2,
      background: (theme) => theme.palette.grey[100],
      border: (theme) => `1px solid ${theme.palette.grey[300]}`,
    }}
  >
    <img src="/bcms-blue.svg" alt="logo" />
    <Stack
      className="safety"
      direction="row"
      sx={{ gap: 0.5, alignItems: "center" }}
    >
      <img src="/safety.svg" alt="logo" />
      <Typography sx={{ fontWeight: "600", color: "success.main" }}>
        Safety
      </Typography>
    </Stack>
  </Stack>
);
